<div class="token-ballance" [ngClass]="['token-ballance--' + size]">
  <span class="token-ballance__available-tokens">{{ availableTokens }}</span>
  <img
    class="token-ballance__available-tokens-icon"
    src="assets/images/bfcoin.png"
    alt="BF Coins"
    height="20"
  />
</div>
